import $ from 'jquery';
import 'select2';

$('select:not(.no-select2)').each(function () { 
    $(this).select2({
        width: '100%',
        minimumResultsForSearch: -1, // disable search box
    });

    //Set placeholder class for styling if the select value is empty. The default placeholder implementation by select2 removes the first option.
    setPlaceholderClass($(this));
    $(this).on('change', function () {
        setPlaceholderClass($(this));
    })
})

function setPlaceholderClass($select) {
    if($select.val() === '') {
        $select.siblings('.select2').find('.select2-selection').addClass('select2-selection--placeholder');
    } else {
        $select.siblings('.select2').find('.select2-selection').removeClass('select2-selection--placeholder');
    }
}
